shadow$provide[454] = function(require,module,exports) {
module.exports=(ReactJSXRuntime);
};